<template>
	<v-layout row justify-center>
		<v-dialog
			:fullscreen="fullscreen"
			class="mobileFullscreen"
			v-model="showModal"
			lazy
			max-width="800px"
			:transition="utils.getSettings('animation')"
			@keydown.esc="showModal = false"
		>
			<v-card class="compact">
				<v-tabs v-model="active" color="blue darken-3" dark>
					<v-tab v-for="tab in tabs" :key="tab" :href="'#' + tab" ripple>
						{{ tab }}
						<v-progress-circular
							indeterminate
							color="white"
							v-if="priceLoading && tab === 'Kostenoverzicht'"
						></v-progress-circular>
					</v-tab>
					<v-tabs-slider color="yellow"></v-tabs-slider>
					<v-tabs-items>
						<v-tab-item :key="'Gegevens'" :value="'Gegevens'">
							<v-card class="compact">
								<v-card-title>
									<h2>Nieuwe reservering</h2>
								</v-card-title>
								<v-form v-model="valid" ref="form" lazy-validation>
									<v-card-text>
										<v-container grid-list-md px-0>
											<v-layout wrap px-0>
												<v-flex xs12 sm12>
													<v-text-field
														label="Omschrijving"
														type="text"
														v-model="selectedReservation.rentDescription"
														required
														:rules="basicRules"
													></v-text-field>
												</v-flex>
												<v-flex xs12>
													<v-select
														v-bind:items="units"
														v-model="unitId"
														label="Selecteer auto"
														item-text="fullDescription"
														item-value="unitId"
														single-line
														required
														:rules="basicRules"
														menu-props="{contentClass:'dialogDropdown','bottom':true}"
													></v-select>
												</v-flex>
												<v-flex xs8 sm5>
													<v-dialog
														ref="menu"
														:close-on-content-click="false"
														v-model="menu"
														transition="scale-transition"
														offset-y
														full-width
														width="290px"
														:return-value.sync="selectedReservation.startDate"
													>
														<v-text-field
															slot="activator"
															label="Startdatum"
															v-model="fullStartDate"
															prepend-icon="event"
															readonly
														></v-text-field>
														<v-date-picker
															v-model="selectedReservation.startDate"
															@change="
																$refs.menu.save(selectedReservation.startDate);
																startDateChanged();
															"
															locale="nl"
															scrollable
														>
															<v-spacer></v-spacer>
															<v-btn flat color="primary" @click="menu = false"
																>Annuleren</v-btn
															>
														</v-date-picker>
													</v-dialog>
												</v-flex>
												<v-flex xs3 md4>
													<v-text-field
														label="Tijd"
														v-model="selectedReservation.startTime"
														type="time"
													></v-text-field>
												</v-flex>
												<v-flex xs1 sm1 md1>
													<select-period
														@setPeriod="setPeriod($event)"
														:time="this.selectedReservation.startTime"
														:day="this.selectedReservation.startDate"
													></select-period>
												</v-flex>
												<v-flex xs8 sm5>
													<v-dialog
														ref="menu2"
														:close-on-content-click="false"
														v-model="menu2"
														transition="scale-transition"
														offset-y
														full-width
														width="290px"
														:return-value.sync="selectedReservation.endDate"
													>
														<v-text-field
															slot="activator"
															label="Einddatum"
															v-model="fullEndDate"
															prepend-icon="event"
															readonly
														></v-text-field>
														<v-date-picker
															v-model="selectedReservation.endDate"
															locale="nl"
															@change="
																$refs.menu2.save(selectedReservation.endDate)
															"
															scrollable
														>
															<v-spacer></v-spacer>
															<v-btn flat color="primary" @click="menu2 = false"
																>Annuleren</v-btn
															>
														</v-date-picker>
													</v-dialog>
												</v-flex>
												<v-flex xs3 md4>
													<v-text-field
														label="Tijd"
														v-model="selectedReservation.endTime"
														type="time"
													></v-text-field>
												</v-flex>
												<v-flex xs1 sm1 md1>
													<v-checkbox
														label="Max eindtijd"
														v-model="selectedReservation.hasMaxTime"
														class="maxEnd"
													></v-checkbox>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Kosten"
														type="text"
														v-model="selectedReservation.cost"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-text-field
														label="Km prijs"
														type="number"
														min="0"
														step="0.01"
														v-model="selectedReservation.kmPrice"
													></v-text-field>
												</v-flex>
												<v-flex md4 xs3>
													<v-text-field
														label="Korting"
														type="number"
														min="0"
														step="0.01"
														v-model="selectedReservation.discount"
													></v-text-field>
												</v-flex>
												<v-flex xs8>
													<v-autocomplete
														@keyup="searchUser"
														label="Zoek gebruiker"
														:loading="loading"
														item-text="Name"
														item-value="user_id"
														placeholder="Voornaam, achternaam, e-mail"
														:no-data-text="search ? 'Geen resultaten' : ''"
														autocomplete="false"
														chips
														:items="items"
														:search-input.sync="search"
														required
														:rules="basicRules"
														v-model="select"
														v-if="!newUserCreated"
													></v-autocomplete>
													<v-text-field
														v-if="newUserCreated"
														label="Naam"
														type="text"
														:value="selectedUser.firstname"
													></v-text-field>
												</v-flex>
												<v-flex xs4>
													<v-btn
														v-if="!newUserCreated"
														color="primary"
														flat
														@click="newUser($event)"
														>Nieuw
														{{
															tempCustomer.t_name
																? '(' + tempCustomer.t_name + ')'
																: ''
														}}</v-btn
													>
													<v-btn
														v-if="newUserCreated"
														color="primary"
														flat
														@click="newUserCreated = false"
														>Wijzig</v-btn
													>
												</v-flex>
												<v-flex xs6 md6>
													<v-text-field
														label="Telefoonummer"
														type="text"
														v-if="select"
														v-model="selectedReservation.phoneno"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs6>
													<v-text-field
														label="Woonplaats"
														type="text"
														v-if="select"
														v-model="selectedReservation.city"
														readonly
													></v-text-field>
												</v-flex>
												<v-flex xs6>
													<v-checkbox
														label="Stuur bevestiging"
														v-model="selectedReservation.sendConfirmation"
													></v-checkbox>
												</v-flex>
											</v-layout>
											<small>* verplichte velden</small>
										</v-container>
									</v-card-text>
								</v-form>
							</v-card>
						</v-tab-item>
						<v-tab-item :key="'Kostenoverzicht'" :value="'Kostenoverzicht'">
							<v-card>
								<v-card-title>
									<h2>Kostenoverzicht #{{ selectedReservation.id }}</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap>
											<reservation-cost-details
												v-if="showModal"
												:reservation="selectedReservation"
												:editable="true"
											/>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>
						<v-tab-item key="Aanvullend" value="Aanvullend">
							<v-card>
								<v-card-title>
									<h2>Aanvullende gegevens</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap mt-3>
											<v-flex xs4>
												<v-text-field
													label="Kmstand start"
													type="number"
													v-model="selectedReservation.kmStart"
												></v-text-field>
											</v-flex>
											<v-flex xs4>
												<v-text-field
													label="Brandstof start"
													type="number"
													v-model="selectedReservation.fuelStart"
												></v-text-field>
											</v-flex>
											<v-flex xs12>
												<v-textarea
													name="remarks"
													label="Vul hier in"
													value
													v-model="selectedReservation.remarks"
												></v-textarea>
											</v-flex>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>
						<v-tab-item :key="'Klantgegevens'" :value="'Klantgegevens'">
							<v-container grid-list-md pa-2>
								<customer-card :user="selectedUser"></customer-card>
								<temp-customer
									:user="tempCustomer"
									:optional="true"
								></temp-customer>
							</v-container>
						</v-tab-item>
						<v-layout row wrap>
							<v-flex xs8>
								<v-btn color="darken-1" flat @click.native="closeModal()"
									>Sluiten</v-btn
								>
							</v-flex>
							<v-flex xs4 text-xs-right>
								<v-btn
									color="primary darken-1"
									:disabled="saveDisabled"
									@click.native="createReservation()"
									>Opslaan</v-btn
								>
							</v-flex>
						</v-layout>
					</v-tabs-items>
				</v-tabs>
			</v-card>
		</v-dialog>
		<reservation-prices
			:reservation="selectedReservation"
			:edit="editPrices"
		></reservation-prices>
	</v-layout>
</template>
<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import { _ } from 'vue-underscore';
import ReservationPrices from '@/components/Reservations/ReservationPrices';
import ReservationCostDetails from '@/components/Reservations/ReservationCostDetails';
import CustomerCard from '@/components/subcomponents/CustomerCard';
import TempCustomer from '@/components/subcomponents/TempCustomer';
import SelectPeriod from '@/components/Reservations/SelectPeriod';
export default {
	name: 'selectedReservationModal',
	components: {
		ReservationCostDetails,
		ReservationPrices,
		CustomerCard,
		TempCustomer,
		SelectPeriod
	},
	created: function() {
		let self = this;
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}

		window.emitter.$on('userCreated', function(data) {
			if (data.type === 'new') {
				self.tempCustomerId = '';
				self.selectedUser = data.user && data.user.length ? data.user[0] : {};
				self.selectedReservation.user_id = self.selectedUser.user_id;
				self.items[0] = self.selectedUser;
				self.select = self.selectedReservation.user_id;
				self.newUserCreated = true;
			} else {
				self.tempCustomerId = data.user;
				self.tempCustomer = data.tempCustomer;
			}
		});
	},
	data() {
		return {
			tabs: ['Gegevens', 'Kostenoverzicht', 'Aanvullend', 'Klantgegevens'],
			active: '',
			menu: false,
			menu2: false,
			dialog: false,
			loading: false,
			valid: false,
			saveDisabled: false,
			priceLoading: false,
			editPrices: {
				showModal: false
			},
			unitDate: {},
			unitId: 0,
			selectedReservation: {
				costData: {
					additionalItems: []
				},
				additionalItems: []
			},
			startDateSet: false,
			search: null,
			searchUsers: [],
			editUser: false,
			unitId: '',
			select: '',
			items: [],
			basicRules: [v => !!v || 'Verplicht veld'],
			utils: utils,
			fullscreen: false,
			tempCustomerId: '',
			selectedUser: {},
			tempCustomer: {},
			showModal: false,
			newUserCreated: false,
			emptyReservation: {
				rentDescription: '',
				unitId: '',
				startDate: '',
				endDate: '',
				discount: 0,
				startTime: '00:00',
				endTime: '00:00',
				costData: {
					additionalItems: []
				},
				fuelStart: '',
				sensors: {},
				status: {},
				showPricesModal: false
			},
			selectedReservation: {
				startDate: '',
				endDate: '',
				startTime: '00:00',
				endTime: '00:00',
				discount: 0,
				costData: {
					additionalItems: []
				},
				fuelStart: '',
				sensors: {},
				status: {},
				showPricesModal: false,
				checkData: true
			}
		};
	},
	props: ['user', 'edit', 'id', 'units'],
	computed: {
		fullStartDate() {
			return this.utils.getFullDate(this.selectedReservation.startDate);
		},
		fullEndDate() {
			return this.utils.getFullDate(this.selectedReservation.endDate);
		}
	},
	watch: {
		unitId: function(val, oldVal) {
			if (val) {
				var selectedUnit = _.where(this.units, { unitId: val });
				this.selectedReservation.freeMileage = selectedUnit[0].freeMileage;
				this.selectedReservation.kmPrice = selectedUnit[0].kmPrice;
				this.selectedReservation.rentDescription =
					this.selectedReservation.rentDescription &&
					this.selectedReservation.rentDescription.indexOf('Verhuur') < 0
						? this.selectedReservation.rentDescription
						: 'Verhuur ' + selectedUnit[0].name + ' ' + selectedUnit[0].license;
				this.selectedReservation.unitId = val;
				this.getReservationCost();
			}
		},
		newUserCreated: function(val) {
			if (!val) {
				this.tempCustomerId = '';
				this.selectedUser = {};
				this.selectedReservation.user_id = 0;
				this.items = [];
				this.select = '';
			}
		},
		'selectedReservation.showModal': function(newVal) {
			if (newVal) {
				this.selectedReservation.vat = 21;
				this.selectedReservation.additionalItems = [];
				this.active = 'Gegevens';
				this.select = '';
				this.search = null;
				if (this.selectedReservation.unitId) {
					this.unitId = this.selectedReservation.unitId;
				} else {
					this.unitId = '';
				}
			}
		},
		search(val) {
			val && this.querySelections(val);
		},
		select(newVal) {
			if (newVal) {
				var selectedUser = _.findWhere(this.items, { user_id: newVal });
				this.selectedUser = selectedUser;
				this.selectedReservation.username = selectedUser.username;
				this.selectedReservation.phoneno = selectedUser.phoneno;
				this.selectedReservation.city = selectedUser.city;
			}
		},
		'selectedReservation.startDate': function(value) {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.endDate': function() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.startTime': function() {
			if (this.checkData) {
				this.checkReservationDates();
				this.getReservationCost();
			}
		},
		'selectedReservation.endTime': function() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.discount': function() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.unitId': function() {
			//	if (this.checkData) {
			this.checkReservationDates();
			this.getReservationCost();
			//	}
		},
		'selectedReservation.hasMaxTime': function() {
			this.getReservationCost();
		}
	},
	methods: {
		openModal() {
			this.items = [];
			this.search = '';
			this.select = '';
			this.active = 'Gegevens';
			this.showModal = true;
		},
		initReservation() {
			// if (this.$refs.form) {
			//   this.$refs.form.reset();
			// }
			const today = new Date();
			const todayMoment = moment(today).format('YYYY-MM-DD');
			const startHours =
				today.getHours() < 10 ? '0' + today.getHours() : today.getHours();
			const startTime =
				today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
			const endTime = moment(startHours + ':00', 'HH:mm')
				.add(1, 'hours')
				.format('HH:mm');
			this.selectedReservation = _.clone(this.emptyReservation);
			this.selectedUser = {};
			this.tempCustomer = {};
			this.unitId = 0;
			this.selectedReservation.startDate = todayMoment;
			this.selectedReservation.startTime = startHours + ':' + startTime;
			this.selectedReservation.endDate = todayMoment;
			this.selectedReservation.endTime = endTime;
			this.selectedReservation.discount = 0;
			this.openModal();
		},
		openModalWithData(
			startDate,
			startTime,
			endDate,
			endTime,
			unitId,
			userId,
			currentReservation
		) {
			let self = this;
			this.checkData = false;

			if (currentReservation) {
				this.selectedReservation = Object.assign({}, currentReservation);
			}

			this.selectedReservation.startDate = startDate;
			this.selectedReservation.startTime = startTime;
			this.selectedReservation.endDate = endDate;
			this.selectedReservation.endTime = endTime;

			// Trigger to enable watch data
			setTimeout(function() {
				self.checkData = true;
				self.selectedReservation.unitId = unitId;
			}, 0);
			this.unitId = unitId;
			if (userId) {
				this.selectedReservation.user_id = userId;
				this.utils
					.getData(basePath + 'api/users/getUser/' + userId)
					.then(function(json) {
						if (json.data) {
							self.selectedUser = json.data[0];
							self.selectedUser.Name =
								self.selectedUser.firstname +
								' ' +
								self.selectedUser.lastname +
								' ' +
								self.selectedUser.username;
							self.items.push(self.selectedUser);
							self.select = userId;
						}
					});
			}
			this.openModal();
		},
		closeModal() {
			this.showModal = false;
		},
		querySelections(v) {
			var self = this;
			this.loading = true;
			var data = {
				query: v
			};
			utils
				.setData(basePath + 'api/users/searchUsers/', data)
				.then(function(response) {
					if (response && response.data) {
						self.items = response.data;
					}
					self.loading = false;
				});
		},
		getReservationCost() {
			var self = this;
			if (this.selectedReservation.unitId) {
				this.priceLoading = true;
				let data = _.clone(this.selectedReservation);
				let additionalItems = data.costData['additionalItems'];
				data.costData = {};
				data.hasMaxTime = this.selectedReservation.hasMaxTime;
				data.startDate = moment(
					data.startDate + ':' + data.startTime,
					'YYYY-MM-DD HH:mm'
				).format();
				data.endDate = moment(
					data.endDate + ':' + data.endTime,
					'YYYY-MM-DD HH:mm'
				).format();
				utils
					.setData(basePath + 'api/reservations/newReservationCost/', data)
					.then(function(response) {
						self.priceLoading = false;
						if (response && response.data) {
							self.selectedReservation.costData = response.data;
							self.selectedReservation.cost = response.data.totalDecimal.toFixed(
								2
							);
							self.selectedReservation.costData[
								'additionalItems'
							] = additionalItems;
						}
						self.loading = false;
					});
			}
		},
		createReservation() {
			if (this.$refs.form.validate() && this.validateSelection()) {
				var self = this;
				var data = {
					startDate: moment(
						self.selectedReservation.startDate +
							':' +
							self.selectedReservation.startTime,
						'YYYY-MM-DD HH:mm'
					).format(),
					endDate: moment(
						self.selectedReservation.endDate +
							':' +
							self.selectedReservation.endTime,
						'YYYY-MM-DD HH:mm'
					).format(),
					user_id: this.select ? this.select : self.selectedReservation.user_id,
					prices: this.selectedReservation.costData.prices,
					unitId: self.selectedReservation.unitId,
					direct: false,
					kmPrice: self.selectedReservation.kmPrice,
					discount: self.selectedReservation.discount,
					freeMileage: self.selectedReservation.freeMileage,
					rentDescription: self.selectedReservation.rentDescription,
					sendConfirmation: self.selectedReservation.sendConfirmation,
					tempCustomerId: self.tempCustomerId,
					tempCustomer: self.tempCustomer,
					useTempCustomer: self.tempCustomer ? true : false,
					additionalItems: self.selectedReservation.costData.additionalItems,
					fuelStart: self.selectedReservation.fuelStart,
					kmStart: self.selectedReservation.kmStart,
					kmEnd: self.selectedReservation.kmStart,
					hasMaxTime: self.selectedReservation.hasMaxTime
				};

				self.showLoader(true);
				utils
					.setData(basePath + 'api/reservations/newReservation/', data)
					.then(function(json) {
						self.showLoader(false);
						self.updateModel('update', json['data']);
					});
				this.showModal = false;
			}
		},
		validateSelection() {
			return this.select && this.select.length;
		},
		deleteReservation() {
			var self = this;
			utils
				.getData(basePath + 'api/reservations/deleteReservation/' + this.id)
				.then(function(json) {
					self.updateModel('remove', this.id);
				});
			this.showModal = false;
		},
		updateModel(action, reservationId) {
			this.select = null;
			window.emitter.$emit('updateReservations', {
				action: action,
				id: reservationId
			});
			this.$emit('update', { id: reservationId });
		},
		searchUser(e) {
			// if (e.code == 'Backspace') {
			//   if (this.select) {
			//     this.select = null;
			//     this.search = '';
			//   }
			// }
		},
		newUser(event) {
			this.tempCustomerId = '';
			this.tempCustomer = {};
			this.$emit('newUser');
		},
		getUnitsPrices() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/rentunits/getUnitPrices/' +
						this.selectedReservation.unitId
				)
				.then(function(json) {
					if (json && json.data) {
						self.selectedReservation.costData.prices = json.data;
					}
				});
		},
		allowedStartDates(val) {
			var yd = new Date();
			yd.setDate(yd.getDate() - 1);
			return moment(val, 'YYYY-MM-DD').isAfter(moment(yd));
			//return moment(val, "YYYY-MM-DD").isBefore(moment(this.selectedReservation.endDate)) || moment(val, "YYYY-MM-DD").isSame(moment(this.selectedReservation.endDate), 'day');
		},
		allowedEndDates(val) {
			return (
				moment(val, 'YYYY-MM-DD').isAfter(
					moment(this.selectedReservation.startDate)
				) ||
				moment(val, 'YYYY-MM-DD').isSame(
					moment(this.selectedReservation.startDate),
					'day'
				)
			);
		},
		showLoader(enable) {
			window.emitter.$emit('showLoading', {
				enable: enable,
				msg: 'Gegevens ophalen'
			});
		},
		startDateChanged() {
			if (!this.startDateSet) {
				this.selectedReservation.endDate = this.selectedReservation.startDate;
				this.startDateSet = true;
			}
		},
		checkReservationDates() {
			if (
				!moment(
					this.selectedReservation.startDate +
						' ' +
						this.selectedReservation.startTime,
					'YYYY-MM-DD HH:mm'
				).isBefore(
					moment(
						this.selectedReservation.endDate +
							' ' +
							this.selectedReservation.endTime,
						'YYYY-MM-DD HH:mm'
					)
				)
			) {
				window.emitter.$emit('showToastMessage', {
					msg: 'Startdatum ligt na de einddatum',
					type: 'error'
				});
				this.saveDisabled = true;
			} else {
				this.saveDisabled = false;
			}
		},
		setPeriod(data) {
			if (data.endTime) {
				this.selectedReservation.endTime = data.endTime;
			}
			if (data.endDate) {
				this.selectedReservation.endDate = data.endDate;
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Reservations/NewReservationModal.vue